import { render } from "./CategoryItem.vue?vue&type=template&id=265e26e6&scoped=true"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"

import "./CategoryItem.vue?vue&type=style&index=0&id=265e26e6&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265e26e6"]])

export default __exports__